/**
 * 「重新开始」的跨组件登记处。
 *
 * 为什么需要它：头部（`AppHeader`）里的「新会话」按钮与聊天视图是**兄弟节点**，
 * 谁也 provide 不到谁；而且 Next 版的教训是"用导航来清空会话"会把正在流式的请求
 * 连同组件一起卸掉（`router.replace` 在旧实现里退化成整页跳转，直接掐断了 SSE）。
 * 所以清空动作必须是一条**显式调用链**：头部 → 登记处 → 聊天视图自己重置，
 * 全程不碰路由。
 */

type ResetHandler = () => void;

let handler: ResetHandler | null = null;

/** 聊天视图挂载时登记自己；返回注销函数，在 `onUnmounted` 里调用。 */
export function registerChatReset(next: ResetHandler): () => void {
  handler = next;
  return () => {
    if (handler === next) {
      handler = null;
    }
  };
}

/** 请求重置当前会话；没有挂载的聊天视图时静默忽略（例如在登录页点头部按钮）。 */
export function requestChatReset(): void {
  handler?.();
}

/** 当前是否有一个聊天视图在监听（测试与头部按钮的禁用态使用）。 */
export function hasChatResetHandler(): boolean {
  return handler !== null;
}
